export const nfseCoreErrorMappings = {
    NFSE_UNLINK_NOT_LINKED: {
        code: 'NFSE_UNLINK_NOT_LINKED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Esta nota fiscal não está vinculada a nenhuma cobrança.',
            },
            {
                language: 'pt-BR',
                message: 'Esta nota fiscal não está vinculada a nenhuma cobrança.',
            },
            {
                language: 'en-US',
                message: 'This invoice is not linked to any billing.',
            },
            {
                language: 'es-ES',
                message: 'Esta factura no está vinculada a ningún cobro.',
            },
        ],
        technicalMessage: 'nota fiscal não está vinculada a nenhuma cobrança',
        severity: 'warning',
        critical: false,
    },
    NFSE_NOT_FOUND_COMPANY: {
        code: 'NFSE_NOT_FOUND_COMPANY',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Empresa não encontrada com os parâmetros informados.',
            },
            {
                language: 'en-US',
                message: 'Company not found with the provided parameters.',
            },
            {
                language: 'es-ES',
                message: 'Empresa no encontrada con los parámetros proporcionados.',
            },
            {
                language: 'pt-BR',
                message: 'Empresa não encontrada com os parâmetros informados.',
            },
        ],
        technicalMessage: 'Não localizamos qualquer Empresa com os parâmetros informados',
        severity: 'error',
        critical: false,
    },
    NFSE_SERVICE_TOKEN_ERROR: {
        code: 'NFSE_SERVICE_TOKEN_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Erro ao conectar com o serviço de NFSe. Tente novamente.',
            },
            {
                language: 'en-US',
                message: 'Error connecting to NFSe service. Please try again.',
            },
            {
                language: 'es-ES',
                message: 'Error al conectar con el servicio de NFSe. Intente nuevamente.',
            },
            {
                language: 'pt-BR',
                message: 'Erro ao conectar com o serviço de NFSe. Tente novamente.',
            },
        ],
        technicalMessage: 'Erro ao obter token do portal',
        severity: 'error',
        critical: false,
    },
    NFSE_DUPLICATE_CERTIFICATE: {
        code: 'NFSE_DUPLICATE_CERTIFICATE',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Já existe um certificado com os parâmetros informados.',
            },
            {
                language: 'en-US',
                message: 'A certificate with the provided parameters already exists.',
            },
            {
                language: 'es-ES',
                message: 'Ya existe un certificado con los parámetros proporcionados.',
            },
            {
                language: 'pt-BR',
                message: 'Já existe um certificado com os parâmetros informados.',
            },
        ],
        technicalMessage: 'Já existe um Certificado com os parâmetros informados',
        severity: 'error',
        critical: false,
    },
    NFSE_CERTIFICATE_DATA_ERROR: {
        code: 'NFSE_CERTIFICATE_DATA_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Erro ao obter os dados do certificado. Verifique o arquivo enviado.',
            },
            {
                language: 'en-US',
                message: 'Error retrieving certificate data. Please check the uploaded file.',
            },
            {
                language: 'es-ES',
                message: 'Error al obtener los datos del certificado. Verifique el archivo cargado.',
            },
            {
                language: 'pt-BR',
                message: 'Erro ao obter os dados do certificado. Verifique o arquivo enviado.',
            },
        ],
        technicalMessage: 'Erro ao obter os dados do certificado',
        severity: 'error',
        critical: false,
    },
    NFSE_CREATION_ERROR: {
        code: 'NFSE_CREATION_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Houve um problema na criação da NFSe. Tente novamente.',
            },
            {
                language: 'en-US',
                message: 'There was a problem creating the NFSe. Please try again.',
            },
            {
                language: 'es-ES',
                message: 'Hubo un problema al crear la NFSe. Intente nuevamente.',
            },
            {
                language: 'pt-BR',
                message: 'Houve um problema na criação da NFSe. Tente novamente.',
            },
        ],
        technicalMessage: 'Houve um problema na criação da NFSe',
        severity: 'error',
        critical: false,
    },
    NFSE_NOT_FOUND_CEP: {
        code: 'NFSE_NOT_FOUND_CEP',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'CEP não encontrado. Verifique se o CEP do tomador está correto.',
            },
            {
                language: 'pt-BR',
                message: 'CEP não encontrado. Verifique se o CEP do tomador está correto.',
            },
            {
                language: 'en-US',
                message: 'ZIP code not found. Please check if the recipient ZIP code is correct.',
            },
            {
                language: 'es-ES',
                message: 'Código postal no encontrado. Verifique que el código postal del tomador sea correcto.',
            },
        ],
        technicalMessage: 'Não localizamos qualquer CEP com os parâmetros informados',
        severity: 'error',
        critical: false,
    },
    NFSE_CANCEL_INVALID_STATUS: {
        code: 'NFSE_CANCEL_INVALID_STATUS',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Só é possível cancelar notas com status Concluído.',
            },
            {
                language: 'pt-BR',
                message: 'Só é possível cancelar notas com status Concluído.',
            },
            {
                language: 'en-US',
                message: 'Only invoices with status Completed can be cancelled.',
            },
            {
                language: 'es-ES',
                message: 'Solo es posible cancelar notas con estado Completado.',
            },
        ],
        technicalMessage: 'A ação de Cancelar NFSe é permitida apenas para notas com status CONCLUIDO',
        severity: 'warning',
        critical: false,
    },
    NFSE_NOT_FOUND_INVALID_ID: {
        code: 'NFSE_NOT_FOUND_INVALID_ID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Nota fiscal não encontrada. O identificador informado é inválido.',
            },
            {
                language: 'pt-BR',
                message: 'Nota fiscal não encontrada. O identificador informado é inválido.',
            },
            {
                language: 'en-US',
                message: 'Invoice not found. The provided identifier is invalid.',
            },
            {
                language: 'es-ES',
                message: 'Factura no encontrada. El identificador proporcionado es inválido.',
            },
        ],
        technicalMessage: 'Falha ao buscar NFSE, o ID utilizado é inválido',
        severity: 'error',
        critical: false,
    },
    NFSE_ALREADY_CANCELLED: {
        code: 'NFSE_ALREADY_CANCELLED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Esta nota fiscal já foi cancelada.',
            },
            {
                language: 'pt-BR',
                message: 'Esta nota fiscal já foi cancelada.',
            },
            {
                language: 'en-US',
                message: 'This invoice has already been cancelled.',
            },
            {
                language: 'es-ES',
                message: 'Esta factura ya fue cancelada.',
            },
        ],
        technicalMessage: 'A NFSe já foi cancelada',
        severity: 'warning',
        critical: false,
    },
    NFSE_ALREADY_RECONCILED: {
        code: 'NFSE_ALREADY_RECONCILED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Esta nota fiscal já foi conciliada e não pode ser alterada.',
            },
            {
                language: 'pt-BR',
                message: 'Esta nota fiscal já foi conciliada e não pode ser alterada.',
            },
            {
                language: 'en-US',
                message: 'This invoice has already been reconciled and cannot be modified.',
            },
            {
                language: 'es-ES',
                message: 'Esta factura ya fue conciliada y no puede modificarse.',
            },
        ],
        technicalMessage: 'A NFSe já foi conciliada',
        severity: 'warning',
        critical: false,
    },
    NFSE_EMISSION_TEMPORARILY_SUSPENDED: {
        code: 'NFSE_EMISSION_TEMPORARILY_SUSPENDED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A emissão de NFS-e está temporariamente suspensa nesta cidade. Tente novamente mais tarde.',
            },
            {
                language: 'pt-BR',
                message: 'A emissão de NFS-e está temporariamente suspensa nesta cidade. Tente novamente mais tarde.',
            },
            {
                language: 'en-US',
                message: 'NFS-e issuance is temporarily suspended in this city. Please try again later.',
            },
            {
                language: 'es-ES',
                message: 'La emisión de NFS-e está temporalmente suspendida en esta ciudad. Intente nuevamente más tarde.',
            },
        ],
        technicalMessage: 'A emissão de NFS-e encontra-se temporariamente interrompida para a cidade',
        severity: 'error',
        critical: false,
    },
    NFSE_SERVICE_INTERNAL_ERROR: {
        code: 'NFSE_SERVICE_INTERNAL_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Ocorreu um erro interno no serviço de NFS-e. Nossa equipe foi notificada.',
            },
            {
                language: 'pt-BR',
                message: 'Ocorreu um erro interno no serviço de NFS-e. Nossa equipe foi notificada.',
            },
            {
                language: 'en-US',
                message: 'An internal error occurred in the NFS-e service. Our team has been notified.',
            },
            {
                language: 'es-ES',
                message: 'Ocurrió un error interno en el servicio de NFS-e. Nuestro equipo fue notificado.',
            },
        ],
        technicalMessage: 'Ocorreu um erro interno, nossa equipe já foi notificado',
        severity: 'error',
        critical: false,
    },
};
